import { type AIChatMessageType } from '@/api/ai';
import { cn } from '@/lib/utils';

import Markdown from './Markdown';
import McpChartHost from './McpChartHost';

const messageClassName =
  'lg:w-[90%] md:w-[95%] w-full rounded-xs bg-aqua-400/30 self-end overflow-x-auto px-6 py-4';

type Props = {
  message: AIChatMessageType;
  className?: string;
};

const AIAssistantMessage = ({ message, className }: Props) => {
  return (
    <div className={cn(messageClassName, className)} data-testid="ai-assistant-message">
      <div className="flex flex-col gap-4">
        {message.blocks.map((block, index) =>
          block.type === 'text' ? (
            <div key={`text-${index}`} data-testid="ai-assistant-text">
              <Markdown>{block.content}</Markdown>
            </div>
          ) : (
            <McpChartHost
              key={`${block.resourceUri}-${index}`}
              resourceUri={block.resourceUri}
              toolName={block.toolName}
              structuredContent={block.structuredContent}
            />
          ),
        )}
      </div>
    </div>
  );
};

export default AIAssistantMessage;
